import React, { Component } from "react";
import { Modal, Button, Form, Input } from "antd";
import Select from "react-select";
import Alert from "react-s-alert";
import { request } from "../../util/APIUtils";
import { API_BASE_URL } from "../../constants";
import { Map, Marker, TileLayer } from "react-leaflet";
import { Label } from "reactstrap";
import "./../pharmacyList/PharmacyList.css";
import "leaflet/dist/leaflet.css";

const { TextArea } = Input;


class MemberPharmacyModal extends Component {
    state = {
        loading: false,
        isMapModalVisible: false,
        selectedLocation: null,
        regions: [],
        pharmacy: {
            name: "",
            phone: "",
            location: "",
            latitude: null,
            longitude: null,
            regionId: null,
            cityId: null,
            citySubDivisionId: null,
        },
    };

    componentDidMount() {
        this.loadRegions();
    }

    loadRegions = () => {
        request({ url: API_BASE_URL + "/regions?size=1000", method: "GET" })
            .then(res => {
                const regions = Array.isArray(res.data)
                    ? res.data
                    : res.data.content || [];
                this.setState({ regions });
            }).catch(() => Alert.error("Bölgeler yüklenemedi"));
    };

    toUpperTR = value =>
        value ? value.toString().toLocaleUpperCase("tr-TR") : "";

    handleSave = () => {
        const { pharmacy } = this.state;
        const { onSave } = this.props;

        if (!pharmacy.name || !pharmacy.phone || !pharmacy.location
            || !pharmacy.cityId || !pharmacy.citySubDivisionId) {
            Alert.error("Eczane adı, Telefon, Adres, İl ve İlçe zorunludur");
            return;
        }

        const city = this.props.cities.find(c => c.id === pharmacy.cityId);
        const subdivision = city && city.citySubDivisions
            ? city.citySubDivisions.find(cs => cs.id === pharmacy.citySubDivisionId)
            : null;

        const dto = {
            name: pharmacy.name,
            phone: pharmacy.phone.replace(/\D/g, "").slice(-10),
            location: pharmacy.location,
            latitude: pharmacy.latitude,
            longitude: pharmacy.longitude,
            regionId: pharmacy.regionId,
            cityId: pharmacy.cityId,
            citySubDivisionId: pharmacy.citySubDivisionId,
            district: subdivision ? subdivision.name : null,
        };

        onSave(dto);
    };


    render() {
        const { visible, onClose } = this.props;
        const { pharmacy, regions, towns, loading } = this.state;

        return (
            <Modal
                title="Yeni Eczane Ekle"
                visible={visible}
                onCancel={onClose}
                footer={null}
                width={800}
                maskClosable={false}
                className="pharmacy-modal"
            >
                <div className="memberForm--main-container">
                    <div className="memberForm-container">
                        <Form>
                            <div className="FormRenk col-sm-12">
                                <span className="form-title">Eczane Bilgileri</span>

                                {/* Eczane Adı */}
                                <div className="row">
                                    <Label className="col-sm-3">
                                        Eczane Adı<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <input
                                            className="form-control uppercase"
                                            value={pharmacy.name}
                                            onChange={e =>
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        name: this.toUpperTR(e.target.value),
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">
                                        Telefon<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <input
                                            className="form-control"
                                            type="tel"
                                            maxLength="10"
                                            placeholder="5XX XXX XX XX"
                                            value={pharmacy.phone}
                                            onChange={e => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, "");
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        phone: onlyNumbers,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">
                                        Adres<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <TextArea
                                            className="form-control uppercase"
                                            rows={3}
                                            style={{ minHeight: 80, resize: "vertical", border: '1px solid #E3E3E3', borderRadius: '4px', padding: '8px' }}
                                            value={pharmacy.location}
                                            onChange={e =>
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        location: this.toUpperTR(e.target.value),
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">
                                        Bölge<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <Select
                                            options={regions.map(r => ({
                                                value: r.id,
                                                label: r.regionName,
                                            }))}
                                            onChange={opt =>
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        regionId: opt ? opt.value : null,
                                                    },
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <Label className="col-sm-3">
                                        İl<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <Select
                                            placeholder="İl seçiniz"
                                            options={this.props.cities.map(c => ({
                                                value: c.id,
                                                label: c.ad
                                            }))}
                                            value={
                                                pharmacy.cityId
                                                    ? {
                                                        value: pharmacy.cityId,
                                                        label: (this.props.cities.find(c => c.id === pharmacy.cityId) || {}).ad
                                                    }
                                                    : null
                                            }
                                            onChange={opt =>
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        cityId: opt ? opt.value : null,
                                                        citySubDivisionId: null
                                                    }
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <Label className="col-sm-3">
                                        İlçe<span className="required-star">*</span> :
                                    </Label>
                                    <div className="col-sm-8 form-group">
                                        <Select
                                            placeholder="İlçe seçiniz"
                                            isDisabled={!pharmacy.cityId}
                                            options={
                                                (this.props.cities.find(c => c.id === pharmacy.cityId) &&
                                                    this.props.cities.find(c => c.id === pharmacy.cityId).citySubDivisions
                                                    ? this.props.cities.find(c => c.id === pharmacy.cityId).citySubDivisions.map(cs => ({
                                                        value: cs.id,
                                                        label: cs.name
                                                    }))
                                                    : [])
                                            }
                                            value={
                                                pharmacy.citySubDivisionId
                                                    ? (() => {
                                                        const city = this.props.cities.find(c => c.id === pharmacy.cityId);
                                                        if (!city || !city.citySubDivisions) return null;
                                                        const cs = city.citySubDivisions.find(cs => cs.id === pharmacy.citySubDivisionId);
                                                        return cs ? { value: cs.id, label: cs.name } : null;
                                                    })()
                                                    : null
                                            }
                                            onChange={opt =>
                                                this.setState({
                                                    pharmacy: {
                                                        ...pharmacy,
                                                        citySubDivisionId: opt ? opt.value : null
                                                    }
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">Enlem :</Label>
                                    <div className="col-sm-8 form-group">
                                        <input
                                            className="form-control"
                                            value={pharmacy.latitude || ""}
                                            onChange={e =>
                                                this.setState({
                                                    pharmacy: { ...pharmacy, latitude: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">Boylam :</Label>
                                    <div className="col-sm-8 form-group">
                                        <input
                                            className="form-control"
                                            value={pharmacy.longitude || ""}
                                            onChange={e =>
                                                this.setState({
                                                    pharmacy: { ...pharmacy, longitude: e.target.value },
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <Button onClick={() => this.setState({ isMapModalVisible: true })}>
                                    Haritadan Konum Seç
                                </Button>

                                <Modal
                                    title="Haritadan Konum Seç"
                                    visible={this.state.isMapModalVisible}
                                    onCancel={() => this.setState({ isMapModalVisible: false })}
                                    onOk={() => {
                                        const { selectedLocation } = this.state;
                                        if (selectedLocation) {
                                            this.setState({
                                                pharmacy: {
                                                    ...pharmacy,
                                                    latitude: selectedLocation.lat.toFixed(6),
                                                    longitude: selectedLocation.lng.toFixed(6),
                                                },
                                                isMapModalVisible: false
                                            });
                                        }
                                    }}
                                    width={800}
                                >
                                    <Map
                                        center={
                                            pharmacy.latitude && pharmacy.longitude
                                                ? [pharmacy.latitude, pharmacy.longitude]
                                                : [37.1588, 38.7939]
                                        }
                                        zoom={15}
                                        style={{ height: 400 }}
                                        onclick={e => this.setState({ selectedLocation: e.latlng })}
                                    >
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                        {(this.state.selectedLocation || pharmacy.latitude) && (
                                            <Marker
                                                position={
                                                    this.state.selectedLocation
                                                        ? this.state.selectedLocation
                                                        : [pharmacy.latitude, pharmacy.longitude]
                                                }
                                            />
                                        )}
                                    </Map>
                                    <p style={{ marginTop: 10 }}>
                                        {this.state.selectedLocation
                                            ? `Seçilen konum: Enlem ${this.state.selectedLocation.lat.toFixed(
                                                6
                                            )}, Boylam ${this.state.selectedLocation.lng.toFixed(6)}`
                                            : pharmacy.latitude && pharmacy.longitude
                                                ? `Kayıtlı konum: Enlem ${parseFloat(pharmacy.latitude).toFixed(
                                                    6
                                                )}, Boylam ${parseFloat(pharmacy.longitude).toFixed(6)}`
                                                : "Haritadan bir konum seçin."}
                                    </p>
                                </Modal>
                            </div>

                            <div style={{ textAlign: "right", marginTop: 20 }}>
                                <div className="save-button-container ">
                                    <button
                                        onClick={this.handleSave}
                                        className="member-save-button"
                                        disabled={loading}
                                    >
                                        KAYDET
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>

        );
    }
}

export default MemberPharmacyModal;



// WEBPACK FOOTER //
// ./src/page/memberList/MemberPharmacyModal.js